import AlertsDetails from '@/pages/alerts/AlertsDetails.vue'
import AlertsHistory from '@/pages/alerts/AlertsHistory.vue'
import AlertsPage from '@/pages/alerts/AlertsPage.vue'

export default [
  {
    path: '/alerts/',
    component: AlertsPage
  },
  {
    path: '/alerts/:mode/:idAlerts',
    component: AlertsDetails,
    props: true
  },
  {
    path: '/alerts/history/',
    component: AlertsHistory
  }
]
